import { ENTITY_TYPES } from '@sales-center/common'
import { validateCustomFields } from '@user/components/CustomFields'
import { useGetEntityFormDataOnMount } from '@user/components/Settings/EntityFormSettings'
import { FormikErrors } from 'formik'
import { useCallback } from 'react'
import { ISaveServicesForLaterFormModel } from '../FormContents/typings'
import { isValidMuiDate } from '@sales-center/common'
import { addDays, isAfter } from 'date-fns'

type Props = {
  totalServicesCount?: number
}

export function useValidate(props: Props) {
  const { totalServicesCount } = props
  const { customFieldSettings } = useGetEntityFormDataOnMount(
    ENTITY_TYPES.Opportunity,
  )

  const validate = useCallback(
    (
      model: ISaveServicesForLaterFormModel,
    ): FormikErrors<ISaveServicesForLaterFormModel> => {
      let errors: FormikErrors<ISaveServicesForLaterFormModel> = {}

      const servicesSelectedCount = model.serviceIds.length

      if (servicesSelectedCount === 0) {
        errors.serviceIds = 'You must select at least one service'
      }

      if (totalServicesCount && servicesSelectedCount === totalServicesCount) {
        errors.serviceIds = 'You must leave at least one service unselected'
      }

      if (!model.salesFunnelId || model.salesFunnelId.length === 0) {
        errors.salesFunnelId = 'Required'
      }

      if (!model.expectedClosingDate) {
        errors.expectedClosingDate = 'Required'
      }

      if (
        model.expectedClosingDate != null &&
        (!isValidMuiDate(model.expectedClosingDate) ||
          isAfter(addDays(new Date(), -1), new Date(model.expectedClosingDate)))
      )
        errors.expectedClosingDate = 'Invalid Date'

      errors = {
        ...errors,
        ...validateCustomFields(model, customFieldSettings),
      }

      return errors
    },
    [customFieldSettings, totalServicesCount],
  )

  return { validate } as const
}
